import React, { Component } from 'react';
import {
    Modal, Form, InputNumber, DatePicker,
} from 'antd';

const FormItem = Form.Item;

class UnwrappedAddRefillModal extends Component {
    render() {
        const {
            visible, onCancel, onCreate, form, confirmLoading,
        } = this.props;
        const { getFieldDecorator } = form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 9 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 11 },
            },
        };

        return (
            <Modal
                visible={visible}
                title="Add Refill"
                style={{ textAlign: 'center', fontSize: '1.2em' }}
                okText="Submit"
                confirmLoading={confirmLoading}
                onCancel={onCancel}
                onOk={onCreate}
            >
                <Form>
                    <FormItem
                        {...formItemLayout}
                        label="Start Date"
                    >
                        {getFieldDecorator('start_date', {
                            rules: [{ required: true, message: 'When to start?' }],
                        })(
                            <DatePicker style={{ width: '100%' }} />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Refill length"
                    >

                        {getFieldDecorator('refill_length', {
                            rules: [{ required: true, message: 'How many days?' }],
                            min: 1,
                        })(
                            <InputNumber min={1} style={{ width: '100%' }} />,
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}

const AddRefillModal = Form.create()(UnwrappedAddRefillModal);


export default AddRefillModal;



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/AddRefillModal.js